import { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles/newNavigationSideBar.css";

import {
  idVerificationPath,
  businessPartner,
  businessPropertiesPath,
} from "../../../routes/routes";

import { UserDataContext } from "../../../contexts/Contexts";
import { SideBarMenuContent } from "./components/SideBarMenuContent";
import { useSidebarProfileImage } from "../../../../infrastructure/hooks/useSidebarProfileImage";
import { IoMenu } from "react-icons/io5";

export const NewSideBarHousing = ({
  uiTexts,
  Texts,
  drawerOnly = false,
  showToggle = true,
}) => {
  const resolvedUiTexts = uiTexts || Texts;
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 1200 });
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);

  const { srcCandidate } = useSidebarProfileImage(userData);

  const isNotVerified = userData?.idTipoUsuario === 1;
  const isVerified = userData?.idTipoUsuario === 2;
  const userType = Number(userData?.idTipoUsuario);
  const avatarTypeClass =
    {
      1: "vn-menu-avatar-button--unverified",
      2: "vn-menu-avatar-button--verified",
      3: "vn-menu-avatar-button--business",
      4: "vn-menu-avatar-button--broker",
    }[userType] || "vn-menu-avatar-button--unverified";

  useEffect(() => {
    if (open) setOpen(false);
  }, [pathname]);

  useEffect(() => {
    const openMenu = () => setOpen(true);
    window.addEventListener("vn-sidebar-menu:open", openMenu);
    return () => window.removeEventListener("vn-sidebar-menu:open", openMenu);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const handleVerifyClick = () => navigate(idVerificationPath);
  const handleBusinessPartnerClick = () => navigate(businessPartner);
  const handleAddPropertyClick = () => navigate(businessPropertiesPath);

  const menu = (
    <SideBarMenuContent
      uiTexts={resolvedUiTexts}
      userData={userData}
      srcCandidate={srcCandidate}
      isMobile={isMobile}
      isNotVerified={isNotVerified}
      isVerified={isVerified}
      onVerifyClick={handleVerifyClick}
      onBusinessPartnerClick={handleBusinessPartnerClick}
      onAddPropertyClick={handleAddPropertyClick}
    />
  );

  if (!isMobile && !drawerOnly) {
    return <aside className="vn-sidebar">{menu}</aside>;
  }

  return createPortal(
    <>
      {showToggle ? (
        <button
          className={`vn-menu-toggle-button ${
            open ? "vn-menu-toggle-button--menu" : "vn-menu-toggle-button--avatar"
          } ${
            !open ? avatarTypeClass : ""
          }`}
          onClick={() => setOpen((prev) => !prev)}
          aria-label={open ? "Cerrar menu" : "Abrir menu"}
          aria-expanded={open}
          type="button"
        >
          {open ? (
            <IoMenu className="vn-menu-toggle-icon" aria-hidden="true" />
          ) : (
            <img
              src={srcCandidate}
              alt=""
              className="vn-menu-avatar-img"
              onError={(event) => {
                event.currentTarget.src = "/img/icons/UserFalse.svg";
              }}
            />
          )}
        </button>
      ) : null}

      {/* VIVA-1024: aqui vivia .vn-overlay, un velo a pantalla completa que al
          abrirse tomaba pointer-events: auto e interceptaba TODOS los clics de la
          pagina. Como el boton de menu es lo unico con z-index por encima, era lo
          unico que seguia respondiendo. Se elimina: el panel deja de ser modal y el
          resto de la pantalla sigue utilizable mientras esta abierto.

          Junto con el se quito el bloqueo de scroll sobre document.body, que iba en
          el mismo patron modal. El scroll de la pagina no debe bloquearse. */}

      <aside
        className={`vn-sidebar vn-sidebar--drawer ${
          drawerOnly ? "vn-sidebar--drawer-forced" : ""
        } ${open ? "is-open" : ""}`}
      >
        {menu}
      </aside>
    </>,
    document.body,
  );
};

export default NewSideBarHousing;
